import { useEffect } from "react";

import {
  FundraiserNavigation,
  FundraisingAtScale,
  WhatWeDoForYou,
  ContactUs,
} from "../components/HomePageComponents";

const HomePage = () => {
  useEffect(() => {
    document.title = "MaMF Home";
  }, []);

  return (
    <div style={{ margin: 0, padding: 0, overflowX: "hidden" }}>
      <div style={{ marginTop: 0 }}>
        <FundraiserNavigation />
      </div>
      <FundraisingAtScale />
      <WhatWeDoForYou />
      <ContactUs />
    </div>
  );
};

export default HomePage;
